import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import Modal from "react-modal";

const SalaryCalculationList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [docurl, setDocUrl] = useState(false);

  const [AttendanceId, setAttendanceId] = useState(null);

  const { sendRequest: getAttendance } = useHttp();

  const getAllData = () => {
    getAttendance(
      {
        url: `/api/salaryCalculation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
        }
      }
    );
  };

  useEffect(() => {
    getAllData();
  }, []);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "500px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
   // //console.log(data);

    const warehouseId = data && data.warehouseId;
    // const attendanceDate = moment(data && data.attendanceDate).format(
    //   "DD/MM/YYYY"
    // );

    getAttendance(
      {
        url: `/api/salaryCalculation/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${warehouseId}`,
      },
      (res) => {
        //console.log(res);
        setSelectedData(res);
      }
    );

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const Shift = (option) => {
    switch (option) {
      case 1:
        return "First Shift";
      case 2:
        return "Second Shift";
      case 3:
        return "Third Shift";
    }
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Salary Calculation</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Salary Calculation
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center table-sm">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>WareHouse</th>
                          <th>Employee Name</th>
                          <th>Month </th>
                          <th>Gross Amount </th>
                          <th>Payable Amount </th>

                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.salaryCalculationDate}</td>
                                <td>{itm.warehouseName}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.monthText}</td>

                                <td>{itm.grossSalary}</td>
                                <td>{itm.finalPayoutSalary}</td>
                                <td>
                                  {" "}
                                  <button
                                    onClick={() => openModal(itm)}
                                    className="btn"
                                  >
                                    <i className="fas fa-eye"></i> 
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <br />
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        
       
        {selectedData && (
          <div className="">
            <h4 className="card-title">Employee Attendance Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            <div className="row">
              <p className="col-md-3">
                <b>Date:</b> {selectedData[0].attendanceDate}
              </p>
              <p className="col-md-3">
                <b> WareHouse Name:</b> {selectedData[0].warehouseName}
              </p>
            </div>

            <table className="table table-bordered table-sm text-center">
              <thead>
                <tr className="">
                  <th>Sr No</th>
                  <th>Employee Name</th>

                  <th>Attendance Type</th>
                  <th>Shift</th>
                  <th>Attendance</th>
                  <th>In Time</th>
                  <th>Out Time</th>
                  <th>Over Time</th>
                  <th>Total Hours</th>
                </tr>
              </thead>
              <tbody>
                {selectedData &&
                  selectedData.map((itm, i) => {
                    return (
                      <tr key={i} className="cursor-pointer">
                        <td>{i + 1}</td>
                        <td>{itm.employeeName}</td>
                        <td>{itm.attendanceType}</td>
                        <td>{Shift(itm.shiftId)}</td>
                        <td>{itm.attendanceStatus ? "Present" : "Absent"}</td>
                        <td>{itm.inTime}</td>
                        <td>{itm.outTime}</td>
                        <td>{itm.overTime}</td>
                        <td>{itm.totalHrs}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default SalaryCalculationList;
